module.exports = __webpack_public_path__ + "img/Group 27488.23ada862.svg";